import Blog1 from "./Blog1";

const blogs = {
    1: Blog1
};

export default blogs